import { t as e } from "../../chunks/index.es.wVhS2yfK.js";
import { Transforms as t } from "slate";
// lib/PrintText/lib/actionHandler.ts
var n = ({ editor: n }) => {
	let r = [{
		id: crypto.randomUUID(),
		class: "block",
		type: "tt/print-text",
		children: [{
			id: crypto.randomUUID(),
			class: "text",
			type: "tt/print-text/text",
			children: [{ text: "" }]
		}, {
			id: crypto.randomUUID(),
			class: "text",
			type: "tt/print-text/role",
			children: [{ text: "question" }]
		}]
	}];
	if (n.selection) {
		t.insertNodes(n, r, { at: n.selection });
		return;
	}
	console.warn("No selection found when inserting");
	let i = e.position(n) + 1;
	t.select(n, {
		anchor: {
			offset: 0,
			path: [
				i,
				0,
				0
			]
		},
		focus: {
			offset: 0,
			path: [
				i,
				0,
				0
			]
		}
	});
};
export { n as actionHandler };
